// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"b0d5fb91","468":"864fab31","493":"1683c4a1","729":"b0d5fb91","985":"b0d5fb91"}[chunkId] + ".chunk.css";
};